"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HowToFixLink = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const Question_svg_1 = __importDefault(require("@veeam/uikit-assets/src/icons/status/Question/Question.svg"));
const core_1 = require("../../../../../../core");
require("./types");
const HowToFixLink = ({ onHowToFixClick }) => {
    const { t } = core_1.useFeatureContext();
    return (react_1.default.createElement(components_1.LinkButton, { iconBefore: Question_svg_1.default, onClick: onHowToFixClick, style: { marginLeft: 42 }, compact: true }, t('dashboard|bottlenecks|howToFix')));
};
exports.HowToFixLink = HowToFixLink;
//# sourceMappingURL=HowToFixLink.js.map